import Navbar from "../../components/navbar";
import MainHeading from "../../components/mainHeading";
import Footer from "../../components/footer";
import HoverButton from "../../components/hoverButton";
import DefaultValueCountry from "../../components/defaultValueCountry";
import Textarea from "../../components/textarea";
import Functions from "./index.function";
import { FormInput } from "../../components";
const ContactUs = () => {
  const {
    handleSubmit,
    onSubmit,
    customSubmitHandler,
    control,
    register,
    setValue,
    loading,
    setCountryCode,
    errors,
    user,
    watch,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Get in touch"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/"}
        />
        <div className="xs:pt-3 sm:pt-4 lg:py-5">
          <h3 className="text-secondary font-unboundedBold xs:text-sm sm:text-base lg:text-lg uppercase">
            My contact details
          </h3>
          <form
            className="flex justify-center items-center flex-col"
            onSubmit={customSubmitHandler}
            noValidate
          >
            <div
              className={
                "w-full sm:gap-2 lg:gap-4 flex justify-start xs:flex-wrap sm:flex-wrap lg:flex-nowrap items-center"
              }
            >
              <div className="relative mt-[18px] xs:w-full sm:w-[49%] lg:w-5/12">
                <FormInput
                  label="Full Name"
                  control={control}
                  name="full_name"
                  type="text"
                  maxLength={50}
                  isMandatory={true}
                  pattern={{
                    value: /^[A-Za-z\s]+$/,
                    message: "Full Name can only contain letters",
                  }}
                  errors={errors}
                />
              </div>
              <div className="relative mt-[18px] xs:w-full sm:w-[49%] lg:w-5/12">
                <FormInput
                  label={"Email Address"}
                  control={control}
                  name="email"
                  type="email"
                  // maxLength={30}
                  isMandatory={false}
                  pattern={{
                    value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                    message: "Please enter a valid email address",
                  }}
                  errors={errors}
                />
              </div>
              <div className="relative mt-[18px] w-full lg:w-5/12">
                <DefaultValueCountry
                  control={control}
                  label="Phone Number"
                  type="text"
                  name="mobile_num"
                  isMandatory={false}
                  defaultValue={user?.mobile_num}
                  countryCode={user?.country_code}
                  register={register}
                  onChange={(value) => setValue("mobile_num", value)}
                  errors={errors}
                  setCountryCode={setCountryCode}
                />
              </div>
            </div>
            <div className="xs:mt-2 sm:mt-2 lg:mt-5 xs:py-2 sm:py-3 lg:py-4 w-full">
              <Textarea
                lable={"Description"}
                name={"description"}
                placeholder="Tell us something about your project"
                register={register}
                isMandatory={true}
                setValue={setValue}
                errors={errors}
              />
            </div>
            <div className="flex justify-start w-full items-center my-10 lg:my-8">
              <HoverButton
                extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform ${
                  loading
                    ? ""
                    : "cursor-pointer hover:scale-105 hover:shadow-md"
                } `}
                BtnTitle={
                  loading ? (
                    <div className="flex justify-center items-center">
                      <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                    </div>
                  ) : (
                    "Submit"
                  )
                }
                disabled={loading}
                type={"submit"}
                BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                  loading
                    ? ""
                    : "group-hover:scale-110 group-hover:text-primary"
                } `}
              />
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;